import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GunDrilling from "../pages/gun-drilling/page";
import DeepHoleDrilling from "../pages/deep-hole-drilling/page";
import News from "../pages/news/page";
import NewsDetail from "../pages/news-detail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gun-drilling-systems",
    element: <GunDrilling />,
  },
  {
    path: "/deep-hole-drilling",
    element: <DeepHoleDrilling />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/news/:slug",
    element: <NewsDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
